__turbopack_context__.v({
  "bar": "r6sGTa_bar",
  "dock": "r6sGTa_dock",
  "pill": "r6sGTa_pill",
  "prompt": "r6sGTa_prompt",
});
